import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useIntl } from 'react-intl-next';
import EmptyState from '@atlaskit/empty-state';
import { messages } from '../../../../messages';
import errorImage from './assets/loading-error.svg';
import { CenteredWrapper } from './styled';
export const ErrorState = ({
  errorContent,
  testId
}) => {
  const {
    formatMessage
  } = useIntl();
  const defaultEmptyStateProps = {
    testId: `${testId}-error`,
    header: formatMessage(messages.errorHeader),
    imageUrl: errorImage
  };
  return /*#__PURE__*/React.createElement(CenteredWrapper, null, errorContent ? /*#__PURE__*/React.createElement(EmptyState, _extends({
    testId: defaultEmptyStateProps.testId
  }, errorContent)) : /*#__PURE__*/React.createElement(EmptyState, defaultEmptyStateProps));
};